import { Autocomplete, Button, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import request from '../../../Helpers/API';
import Swal from 'sweetalert2';
import { GetKey, GetText } from '../../../Helpers/GetKey';
import { useHistory } from "react-router-dom";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PlantillaScreen from '../../helpers/PlantillaScreen';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const PermisosUsuariosAgregarScreen = () => {
  const history = useHistory();
  const [state, setState] = useState({
    usuarioselect: "",
    usuariosearch: "",
    titulosolicitud: "SELECCIONAR USUARIO",
    idusuario: 0,
  });
  const [usuarioNuevolist, setUsuarioNuevoList] = useState([]);

  const usuario = GetText(state.usuariosearch)
  const idusuario = GetKey(state.usuariosearch)

  useEffect(() => {
    request
      .get("RegistrarUsuario/DropDownList")
      .then((result) => {
        setUsuarioNuevoList(result);
      })
      .catch((error) => {
        JSON.stringify("PERMISOS", "ERROR....", "error");
      });
  }, []);

  const onGuardar = () => {

    //   setLoader({ ...loader, mostrar: true });
    const post = {
      idusuario: idusuario,
      password: "",
      bloqueado: 0,
      intentos: 0,
      codigoautenticacion: 0,
    };
    request
      .post(`RegistrarUsuario`, post)
      .then(async () => {
        //   setLoader({ ...loader, mostrar: false });

        await Swal.fire({
          title: "PERMISOS",
          text: "Registro guardado con éxito",
          icon: "success",
          customClass: {
            container: "mi-superpoop",
          },
        });
        history.push("/Permisos/PermisosUsuarios")
      })
      .catch((error) => {
        // setLoader({ ...loader, mostrar: false });
        Swal.fire("PERMISOS", JSON.stringify(error), "error");
      });
  };

  const onHome = () => {
    // setOcultarBusqueda(false)
    history.push("/Permisos/PermisosUsuarios")
  };
  return (
    <PlantillaScreen
      titulo={`AGREGAR USUARIO`}
      className_main={1}
      className={"permisos-usuarios-main-screen"}
    >
      <div className='permisos-usuarios-agregar-main-screen-container'>
        <div>
          <Autocomplete
            size="small"
            id="dash-razonsocial"
            freeSolo
            // className="dash-cliente-search-razonsocial"
            value={state.usuariosearch}
            onChange={(_, newValue) => {
              setState({ ...state, usuariosearch: newValue });
              // Navigate to the selected user route
            }}
            options={usuarioNuevolist.map(
              (option) => `${option.id} - ${option.display}`
            )}
            renderInput={(params) => (
              <TextField {...params} label="Seleccione un Usuario... " />
            )}
          />
        </div>

        <div className="permisos-usuarios-agregar-boton">
          <div className="boton-regresar" onClick={() => onHome()}>
            <ArrowBackIcon /> Regresar
          </div>
          {state.usuariosearch !== null && state.usuariosearch !== 0 && state.usuariosearch !== "" ? (
            <Button className='boton-agregar' variant="contained" onClick={() => onGuardar()}>
              Agregar
              <PersonAddIcon />
            </Button>
          ) : <div></div>}
        </div>




      </div>
    </PlantillaScreen>
  );
}


